export default __webpack_public_path__ + "static/media/1064.8c3534b4.png";